
export class AiRaw {
  number: number = 0;
  value: number = 0;
  hits: number = 0;
}

export interface AiRawList {
  AiRaw: AiRaw[];
}
